export const homeObjOne = {
  primary: false,
  lightBg: true,
  lightTopLine: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'First Coast Hockey Organization',
  headline: 'Serving the greater Jacksonville area',
  description:
    'We are currently working together with the City of Jacksonville to bring you an Outdoor Roller Hockey Facility.',
  buttonLabel: 'More Info',
  imgStart: 'start',
  img: require('../../images/FCHOlogo1.png').default,
  alt: 'Credit Card',
  start: ''
};

export const homeObjTwo = {
  primary: true,
  lightBg: false,
  lightTopLine: false,
  lightText: true,
  lightTextDesc: true,
  topLine: 'Outdoor Inline Hockey Rink',
  headline: 'Team up with First Coast Hockey Organization.',
  description:'This facility will be top of the line and will help grow the sport of hockey while providing a positive environment for children.',
  buttonLabel: 'Help Us',
  imgStart: '',
  img: require('../../images/hockeyrink2.jpg').default,
  img2: require('../../images/hockeyrink1.jpg').default,
  img3: require('../../images/hockeyrink3.jpg').default,
  alt: 'Vault',
  start: ''
};

export const homeObjThree = {
  primary: false,
  lightBg: true,
  lightTopLine: true,
  lightText: false,
  lightTextDesc: false,
  topLine: 'Tim Tebow',
  headline:
    '"These guys love the community and giving back."',
  description:
    '"Love these guys. They love the city and love their sport."',
  buttonLabel: 'Previous Events',
  imgStart: 'start',
  img: require('../../images/Tebow.jpg').default,
  alt: 'Vault',
  start: 'true'
};


export const homeObjFive = {
  img1: require('../../images/mike.jpeg').default,
  img2: require('../../images/ant.jpeg').default,
  img3: require('../../images/jp.jpeg').default,
  alt: 'Vault',
  start: ''
};
